module.exports = "../dist/img/img_4-24.0400.jpg";